import { render, staticRenderFns } from "./ProcessoInteligente.vue?vue&type=template&id=8a6e98aa&scoped=true"
import script from "./ProcessoInteligente.vue?vue&type=script&lang=js"
export * from "./ProcessoInteligente.vue?vue&type=script&lang=js"
import style0 from "./ProcessoInteligente.vue?vue&type=style&index=0&id=8a6e98aa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6e98aa",
  null
  
)

export default component.exports